import React from 'react';
import PropTypes from 'prop-types';

import * as Utils from '@js/modules/utils';

import LazyLoad, {
    forceVisible
} from 'react-lazyload';


export default class LazyLoader extends React.Component {
    static propTypes = {
        children: PropTypes.object.isRequired,
        loadOnMount: PropTypes.bool
    };

    static defaultProps = {
        loadOnMount: false
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (window.seoMode) {
            forceVisible();
        }
    }

    render() {
        const {
            children,
            ...lazyProps
        } = this.props;

        if (Utils.supportScroll() && !this.props.loadOnMount) {
            return (
                <LazyLoad {...lazyProps}>
                    {children}
                </LazyLoad>
            );
        } else {
            return children;
        }
    }
}
